import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminDashboard from '../components/Admin/AdminDashboard';
import ReimbursementValidation from '../components/Admin/ReimbursementValidation';
import FraudAlerts from '../components/Admin/FraudAlerts';
import StructureManagement from '../components/Admin/StructureManagement';

const AdminPage = () => {
  return (
    <div className="page-content">
      <Routes>
        <Route path='accueil' element={<AdminDashboard />} />
        <Route path="reimbursements" element={<ReimbursementValidation />} />
        <Route path="frauds" element={<FraudAlerts />} />
        <Route path="structures" element={<StructureManagement />} />
      </Routes>
    </div>
  );
};

export default AdminPage;